import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IRegion } from 'models/Region'

export const GetRegions = action('GetRegions', payload<IPayload<IRegion[]>>())
export const GetRegionsErrors = action('GetRegionsErrors', payload<IError>())
export const RegionsFetching = action('RegionsFetching', payload<boolean>())
export const UpdateRegion = action('UpdateRegion', payload<IPayload<IRegion>>())
